//
// Copyright (c) 2016 by Curalate, Inc.
//

/*jshint devel: true, jquery: true */
/*global angular: false, moment: true, window: false, _: false */

(function() {
    'use strict';

    var curalate = angular.module('curalate'),
        POLL_INTERVAL = 10000;

    curalate.factory('ProcessingVideosService', ['$rootScope', '$timeout', 'SchedulerService',
        function($rootScope, $timeout, SchedulerService) {
            var processingVideos, polling = false, loadGivenSavedImages, startQueryingVideos, pollVideoCounts, onProcessingFinished;
            processingVideos = [];

            onProcessingFinished = function(itemIds) {
                $rootScope.$broadcast("scheduler:videos-finished-processing", itemIds)
            };

            pollVideoCounts = function() {
                SchedulerService.getProcessingVideos().then(function(res) {
                    var count = res.savedImageIds.length,
                        finishedProcessingVids;

                    finishedProcessingVids = _.difference(processingVideos, res.savedImageIds);
                    processingVideos = res.savedImageIds.slice(0); // make a copy of this array, mostly to fix our jasmine tests...

                    if (finishedProcessingVids.length > 0) {
                        onProcessingFinished(finishedProcessingVids);
                    }

                    if (count > 0) {
                        $timeout(pollVideoCounts, POLL_INTERVAL);
                    } else {
                        // Nothing left processing.
                        polling = false;
                    }
                });
            };

            return {
                startPollingForUpload: function(itemId) {
                    if (processingVideos.indexOf(itemId) === -1) {
                        processingVideos.push(itemId);
                        if (!polling) {
                            polling = true;
                            $timeout(pollVideoCounts, POLL_INTERVAL);
                        }
                    }
                },
                startPolling: function() {
                    if (!polling) {
                        polling = true;
                        pollVideoCounts();
                    }
                },
                stopPolling: function() {
                    if (polling) {
                        polling = false;
                    }
                },
                getCurrentlyProcessingCount: function() {
                    return processingVideos.length;
                }
            };
        }
    ]);

})();
